<template>
  <div class="p-relative tx-wrapper">
    <component
      :is="$route.query.type"
      v-if="currentProject"
      @close="$emit('close')"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Stake from "./Stake";
import Unstake from "./Unstake";
import CancelRequest from "./CancelRequest";
import Claim from "./Claim";

const components = {
  stake: Stake,
  unstake: Unstake,
  cancelRequest: CancelRequest,
  claim: Claim,
};

export default {
  components,
  computed: mapGetters({
    currentProject: "projectConfig/latestProject",
  }),
  beforeCreate() {
    if (!components[this.$route.query.type]) {
      this.$router.replace({
        path: this.$route.path + "?action=tx&type=stake",
      });
    }
  },
};
</script>

<style lang="scss">
.tx-wrapper {
  .deposit-box {
    width: 630px;
    min-height: 650px;
    border: 1px solid #7387ff;
    border-radius: 16px;
  }
}
</style>
